"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseType = void 0;
var PurchaseType;
(function (PurchaseType) {
    PurchaseType["SUBSCRIPTION"] = "subscription";
})(PurchaseType || (exports.PurchaseType = PurchaseType = {}));
